import { useEffect } from 'react'
import { useRealtimeConnection } from './hooks/useRealtimeConnection'
import { useIncomingCallRingtone } from './hooks/useIncomingCallRingtone'
import { useOutgoingCallRingtone } from './hooks/useOutgoingCallRingtone'
import { AppRoutes } from './router'
import { useAuthStore } from './store/authStore'
import { IncomingCallModal } from './components/IncomingCallModal'
import { ActiveCallView } from './components/ActiveCallView'
import { OutgoingCallView } from './components/OutgoingCallView'
import { AppViewport } from './components/AppViewport'
import { registerRTCRemoteLeaveFallback } from './lib/rtcRemoteLeaveFallback'
import { registerPageUnloadCallCleanup } from './lib/pageUnloadCallRelease'

function App() {
  const restore = useAuthStore((state) => state.restore)
  useRealtimeConnection()
  useIncomingCallRingtone()
  useOutgoingCallRingtone()

  useEffect(() => {
    restore()
  }, [restore])

  useEffect(() => registerRTCRemoteLeaveFallback(), [])

  useEffect(() => registerPageUnloadCallCleanup(), [])

  return (
    <AppViewport>
      <AppRoutes />
      <IncomingCallModal />
      <OutgoingCallView />
      <ActiveCallView />
    </AppViewport>
  )
}

export default App
